import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { useFeatureFlags } from 'hooks';
import { routes } from 'constants/config';
import * as assignmentsSelectors from 'selectors/learn/assignments';
import * as contentsSelectors from 'selectors/learn/contents';
import { TEXT_VARIANTS, Text } from 'components/ui/Typography';

const DashboardSidebar = ({
  hasAssignments,
  hasEvents,
  hasLibraryContents,
  hasStartedAny,
  activePage,
}) => {
  const hasOnDemandPractice = useFeatureFlags('practice');
  const hasUnificationFlag = useFeatureFlags('readiness-enable-unification');

  return (
    <div
      className={classnames('DashboardSidebar', {
        'mr-24': hasUnificationFlag,
      })}
    >
      <div className="DashboardSidebar-group">
        {!hasUnificationFlag && (
          <h2 className="DashboardSidebar-header">
            {t('learn.sidebar.headers.learn')}
          </h2>
        )}

        <a
          className={classnames('DashboardSidebar-link', {
            'DashboardSidebar-link-unification': hasUnificationFlag,
          })}
          href={routes.LEARN}
        >
          {t('learn.sidebar.my_learning_content')}
        </a>
        {hasLibraryContents && hasAssignments && (
          <a
            className={classnames('DashboardSidebar-link', {
              'DashboardSidebar-link-unification': hasUnificationFlag,
            })}
            href={routes.LEARN_ASSIGNMENTS}
          >
            {t('learn.sidebar.assignments')}
          </a>
        )}
        {hasStartedAny && (
          <a
            className={classnames('DashboardSidebar-link', {
              'DashboardSidebar-link-unification': hasUnificationFlag,
            })}
            href={routes.LEARN_HISTORY}
          >
            {t('learn.sidebar.history')}
          </a>
        )}
        {hasEvents && (
          <a
            className={classnames('DashboardSidebar-link', {
              'DashboardSidebar-link-unification': hasUnificationFlag,
            })}
            href={routes.IN_PERSON_TRAINING.EVENTS_DASHBOARD}
          >
            {t('learn.sidebar.my_training_events')}
          </a>
        )}
      </div>
      {hasOnDemandPractice && (
        <div
          className={classnames('DashboardSidebar-group', {
            'DashboardSidebar-group-unification': hasUnificationFlag,
          })}
        >
          {!hasUnificationFlag ? (
            <h2 className="DashboardSidebar-header">
              {t('learn.sidebar.headers.practice')}
            </h2>
          ) : (
            <h2 className="DashboardSidebar-header-unification">
              <Text variant={TEXT_VARIANTS.BODY_BOLD}>
                {t('learn.sidebar.headers.practice')}
              </Text>
            </h2>
          )}
          {hasUnificationFlag && (
            <div className="DashboardSidebar--unify-activeLink" />
          )}
          <a
            href={routes.ON_DEMAND_PRACTICE.LEARNING.INDEX(1)}
            className={classnames('DashboardSidebar-link', {
              'DashboardSidebar-link-unification': hasUnificationFlag,
              'CustomColor--borderColor DashboardSidebar-link--active':
                activePage === routes.ON_DEMAND_PRACTICE.LEARNING.INDEX(1),
            })}
          >
            {t('practice.on_demand_practice.title')}
          </a>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  hasAssignments: assignmentsSelectors.hasAssignments(state),
  hasLibraryContents: contentsSelectors.hasLibraryContents(state),
  hasStartedAny: contentsSelectors.hasStartedAny(state),
  hasEvents: !!state.data.events.count,
});

export default connect(mapStateToProps)(DashboardSidebar);
